export default __webpack_public_path__ + "static/media/bonus-ico.060dc206.svg";